/* Veggiet BM v2 (2026-08-01) — subscription pricing helpers.
   Policy: subscription = 1-box variant × qty (2–6) with a selling plan;
   every qty/frequency gets the same % off list price (no bundle stacking).
   UMD-lite so the same file runs in the theme and in jest. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.VGBMv2 = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var MIN_QTY = 2;
  var MAX_QTY = 6;

  function clampSubQty(qty) {
    var q = parseInt(qty, 10);
    if (isNaN(q) || q < MIN_QTY) return MIN_QTY;
    if (q > MAX_QTY) return MAX_QTY;
    return q;
  }

  function subTotalCents(unitCents, qty, discountPct) {
    var q = clampSubQty(qty);
    return Math.round(unitCents * q * (100 - discountPct) / 100);
  }

  function compareTotalCents(unitCents, qty) {
    return unitCents * clampSubQty(qty);
  }

  /* Appstle encodes its selling-plan option value as an internal state dump
     that starts with "<n><UNIT>" (e.g. "1MONTHMIN_CYCLES=3..."). Extract the
     interval; otherwise fall back to the plan name (entity-decoded, since
     Appstle stores names pre-escaped). */
  function parseFreqLabel(optionValue, fallbackName) {
    var m = /^(\d+)(DAY|WEEK|MONTH|YEAR)/i.exec(optionValue || '');
    if (m) {
      var n = parseInt(m[1], 10);
      var unit = m[2].toLowerCase();
      return n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
    }
    return String(fallbackName || '')
      .replace(/&amp;/g, '&')
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"');
  }

  /* Appstle interval token → days, for sorting frequency options. */
  function parseFreqDays(optionValue) {
    var m = /^(\d+)(DAY|WEEK|MONTH|YEAR)/i.exec(optionValue || '');
    if (!m) return null;
    var n = parseInt(m[1], 10);
    var per = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 }[m[2].toUpperCase()];
    return n * per;
  }

  /* "2 boxes" / "1 box" (variant option labels) → box count. */
  function parseQtyFromLabel(label) {
    var m = /(\d+)\s*box/i.exec(label || '');
    return m ? parseInt(m[1], 10) : null;
  }

  return {
    MIN_QTY: MIN_QTY,
    MAX_QTY: MAX_QTY,
    clampSubQty: clampSubQty,
    subTotalCents: subTotalCents,
    compareTotalCents: compareTotalCents,
    parseFreqLabel: parseFreqLabel,
    parseFreqDays: parseFreqDays,
    parseQtyFromLabel: parseQtyFromLabel
  };
});
